import Form from 'shared/components/Form'
import Modal from 'shared/components/Modal'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const ContainerIcon = styled.div`
  display: flex;
  width: 100px;
  height: 100px;
  border: 2px solid ${colors.yellow};
  background-color: ${colors.yellow};
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  svg {
    width: 45px;
    height: 45px;
  }
`

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;

  & > div:last-child {
    padding-top: 8px;
  }
`
interface IModalProps {
  img: string
}

export const StyledModal = styled(Modal)<IModalProps>`
  & > div {
    background-image: url(${props => props.img});
    background-repeat: no-repeat;
  }
`
